// extracted by mini-css-extract-plugin
export default {"GalaxyBG":"styles_GalaxyBG__FcNYx"};